<template>
  <div class="wrapper">
    <p style="text-transform: uppercase; font-weight: bold;">{{ question }}</p>
    <button class="button__submit" @click="returnToForm">
      <span class="button__text">VOTE HERE</span>
      <span class="button__icon">&rarr;</span>
    </button>

    <div class="display">
      <div class="display-grid">
        <div class="display-grid__hint"><p>SOME AGREE</p></div>
        <div class="display-grid__title">{{ title }}</div>

        <div
          v-for="(response, index) in responses"
          :key="`response-${index}`"
          :class="`display-grid__response display-grid__response--${index}`"
        >
          {{ response }}
        </div>

        <div
          v-for="(vote, index) in votes"
          :key="`vote-${index}`"
          :class="`display__vote display__vote--${index}`"
        >
          <span class="vote-counter"
            >+<number
              :ref="vote"
              :from="0"
              :to="vote"
              :duration="1"
              :delay="2 * index + 1"
              easing="Power1.easeOut"
              :format="theFormat"
              @complete="completed"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://www.ngv.vic.gov.au/custom/we-change-the-world/"
    : "http://localhost:8120/";

export default {
  data() {
    return {
      title: "",
      question: "",
      responses: [],
      votes: [],
      userVote: null,
    };
  },
  props: ["formId"],
  methods: {
    theFormat(number) {
      return number.toFixed(0);
    },
    completed() {
      console.log("Animation ends!");
    },
    playAnimation() {
      this.$refs.castle[0].play();
    },
    async fetchData() {
      const status = (response) => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      };

      const json = (response) => {
        return response.json();
      };

      await fetch(BASE_URL + "get")
        .then(status)
        .then(json)
        .then((data) => {
          this.title = data[this.formId].title;
          this.question = data[this.formId].question;
          this.responses = data[this.formId].responses;
          this.votes = data[this.formId].votes;

          document
            .querySelector(".survey-revealer")
            .classList.remove("survey-revealer");

          document.querySelector(".loader").classList.add("survey-revealer");
        })
        .catch((error) => {
          console.log("Request failed", error);
        });
    },
    returnToForm() {
      this.$emit("dismissed", "Animation Hidden!");
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped>

.hidden {
  display: none;
}
.display {
  position: relative;
  max-width: 768px;
  margin: 0 auto;
}
.display-grid {
  display: grid;

  @media screen and (min-width: 580px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.display-grid > * {
  margin-bottom: -2px;
}
.display-grid__hint {
  padding: 0.5em;
  border: 2px solid var(--color-black);
  color: var(--color-black);
  border-bottom: 0;
  display: inline-block;
  font-weight: bold;
  @media screen and (min-width: 580px) {
    grid-column: 2/3;
    grid-row: 1/2;
  }
}

.display-grid__hint p {
  margin: 0;
}
.display-grid__title {
  padding: 1em;

  background-color: var(--color-black);
  color: var(--color-white);

  font-size: clamp(1em, 2vw, 2em);
  @supports not (font-size: clamp(1em, 2vw, 2em)) {
    font-size: min(max(1em, 2vw), 2em);
  }
  @media screen and (min-width: 580px) {
    grid-column: 2/3;
    grid-row: 2/3;
    margin: 0 -5em -2px -5em;
  }
}
.display-grid__response {
  padding: 1.25em;
  text-align: left;
  background-color: var(--color-white);
  color: var(--color-black);
  border: 2px solid var(--color-black);
  transition: 0.3s ease;
  font-size: clamp(1em, 2vw, 1.25em);
  @supports not (font-size: clamp(1em, 2vw, 1.25em)) {
    font-size: min(max(1em, 2vw), 1.25em);
  }
}

.display-grid__response--0 {
  order: 1;
  @media screen and (min-width: 580px) {
    order: unset;

    grid-column: 2/4;
    grid-row: 3/4;
  }
}
.display__vote--0 {
  order: 2;
  @media screen and (min-width: 580px) {
    order: unset;

    grid-column: 3/4;
    grid-row: 4/5;
  }
}
.display-grid__response--1 {
  order: 3;
  @media screen and (min-width: 580px) {
    order: unset;

    grid-column: 1/3;
    grid-row: 4/5;
  }
}
.display__vote--1 {
  order: 4;
  @media screen and (min-width: 580px) {
    order: unset;
    grid-column: 1/2;
    grid-row: 5/6;
  }
}
.display-grid__response--2 {
  order: 5;
  @media screen and (min-width: 580px) {
    order: unset;
    grid-column: 2/4;
    grid-row: 5/6;
  }
}
.display__vote--2 {
  order: 6;
  @media screen and (min-width: 580px) {
    order: -1;
    grid-column: 2/3;
    grid-row: 6/7;
  }
}

.display__media {
  position: relative;
}
.display__vote {
  transition: transform 0.3s ease;
  max-height: 20px;
  border: 2px solid var(--color-black);

  min-width: 80px;
  padding: 1em 2em;
  background-color: var(--color-white);

  /* prettier-ignore */
  box-shadow:
    -1px -1px 0px var(--color-black),
    -2px -2px 0px var(--color-black),
    -3px -3px 0px var(--color-black),
    -4px -4px 0px var(--color-black),
    -5px -5px 0px var(--color-black),
    -6px -6px 0px var(--color-black),
    -7px -7px 0px var(--color-black),
    -8px -8px 0px var(--color-black),
    -9px -9px 0px var(--color-black),
    -10px -10px 0px var(--color-black);

  transform: translate(10px, 10px);

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: clamp(1em, 2vw, 2em);
  @supports not (font-size: clamp(1em, 2vw, 1.25em)) {
    font-size: min(max(1em, 2vw), 1.25em);
  }
}
.button__submit {
  padding: 1em;
  margin-bottom: 2em;
  border: 2px solid var(--color-black);
  border-top: none;

  background-color: var(--color-black);
  color: var(--color-white);

  text-transform: uppercase;
  font-weight: bold;
  font-size: 1em;

  cursor: pointer;
  transition: 0.3s ease;
}
.button__submit:hover {
  background-color: var(--color-black-light);
  color: var(--color-white);
}
.button__icon {
  display: inline-block;
  transform: translateX(0);
  transition: 0.3s ease;
}
.button__submit:hover > .button__icon {
  transform: translateX(3px);
}
</style>
